import { gql } from "@apollo/client";

export const CREATE_PROVEEDOR_DISTRIBUIDOR = gql`
    mutation createProveedorDistribuidor(
        $codigoSAP: String!,
        $razonSocial: String!,
        $contacto: String!,
        $telefonoAdicional: String!,
        $observacion: String!,
        $activo: Boolean!,
        $email: String!,
        $idDeposito: Int!,
        $metodoCobroBulto: [AddProveedorMetodoCobroBultoInput],
        $metodoCobroKilo: [AddProveedorMetodoCobroKiloInput],
        $metodoCobroKM: [AddProveedorMetodoCobroKMInput]
         ){
        createProveedorDistribuidor(
            input: {
                codigoSAP: $codigoSAP,
                razonSocial: $razonSocial,
                contacto: $contacto,
                telefonoAdicional: $telefonoAdicional,
                observacion: $observacion,
                activo: $activo,
                email: $email,
                idDeposito: $idDeposito,
                metodoCobroBulto: $metodoCobroBulto,
                metodoCobroKilo: $metodoCobroKilo,
                metodoCobroKM: $metodoCobroKM
            }
        ) {
            idProveedorDistribuidor
        }
    }
`;